export default __webpack_public_path__ + "static/media/arc-square.2e027b1f.svg";